import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import * as moment from 'moment';

var defaultLng = 'en';

const instance = i18n.use(initReactI18next)
   .use(Backend)
  .use(LanguageDetector)
  .init({
    fallbackLng: defaultLng,
    //lng: defaultLng,
    detection: {
       order: ['querystring', 'cookie', 'localStorage'],
       lookupQuerystring: 'lang'
    },
    react: {
      wait: true,
      useSuspense: false,
      nsMode: 'default',       
    }, 
    // have a common namespace used around the full app
    ns: ['common'],
    defaultNS: 'common',
    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react!!
      formatSeparator: ',',
      format: function(value: string, format: string, lng: string) {
        if (format === 'uppercase') {
            return value.toUpperCase();
        }
        return value;
      }
    }
  }); 

i18n.on('languageChanged', (lang: string) => { 
    if (lang === 'en') {
      moment.updateLocale(lang, {});
    } else {
      //let trLocale = require('moment/locale/' + lang);
      moment.locale(lang);
     // moment.updateLocale(lang, trLocale);
    }
    if (history.pushState) {
      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?lang=' + lang;
      window.history.pushState({path : newurl}, '', newurl);
    }
});

export default instance;